import React from "react";
import http from "services/httpService";
import TpaSetup from "components/Tpa";
import useNavigateInsuranceSetup from "hooks/useNavigateInsuranceSetup";

const TPASetup = () => {
  const { navigateInsurancePlan } = useNavigateInsuranceSetup();

  const handleSubmit = async (values) => {
    await updateTpaDetails(values);
  };

  const updateTpaDetails = async (values) => {
    const userplan_id = JSON.parse(localStorage.getItem("userplan_ids"))[0];
    const payload = {
      userplan_id,
      ...values,
    };
    try {
      const { data } = await http.post(
        `/business/update_tpa_details/`,
        payload
      );
      localStorage.removeItem("gmc_done");
      navigateInsurancePlan();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <section>
      <TpaSetup handleSubmit={handleSubmit} />
    </section>
  );
};

export default TPASetup;
